import { Container } from 'inversify';
import * as React from 'react';

export const DiContainerContext = React.createContext<Container>(new Container());
